import { observable, action } from "mobx";
import { post } from "../services/ajax.service";
class DashboardCommonStore {
  @observable participant = [];
  @observable participant_opioid = []
  @observable drug = [];
  @observable pharmacy_claim_detail = [];
  @observable pharmacy_and_physician_detail = [];
  @observable physician = {};
  @observable pharmacy = {};
  @observable claim = [];
  @observable filterValue = "";
  @observable individual_pharmacy = {}
  @observable url = "/api/v1/dashboard/commons";





  @action sortbydesc(filter) {
    this.filterValue = filter;
    if (this.drug.length > 0) {
      if (filter == "total_cost") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.total_cost) > parseInt(b.total_cost)) return -1;
          if (parseInt(a.total_cost) < parseInt(b.total_cost)) return 1;
          return 0
        })
      }
      if (filter == "plan_pay") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return 1;
          return 0
        })
      }
      if (filter == "co_pay") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return 1;
          return 0
        })
      }
      if (filter == "qty") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.qty) > parseInt(b.qty)) return -1;
          if (parseInt(a.qty) < parseInt(b.qty)) return 1;
          return 0
        })
      }
      if (filter == "days_supply") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.days_supply) > parseInt(b.days_supply)) return -1;
          if (parseInt(a.days_supply) < parseInt(b.days_supply)) return 1;
          return 0
        })
      }
      if (filter == "pharmacy_name") {
        this.drug = this.drug.sort(function (a, b) {
          if ((a.pharmacy_name) > (b.pharmacy_name)) return -1;
          if ((a.pharmacy_name) < (b.pharmacy_name)) return 1;
          return 0
        })
      }
      if (filter == "date_filled") {
        this.drug = this.drug.sort(function (a, b) {
          if ((a.date_filled) > (b.date_filled)) return -1;
          if ((a.date_filled) < (b.date_filled)) return 1;
          return 0
        })
      }
      if (filter == "life_id") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.life_id) > parseInt(b.life_id)) return -1;
          if (parseInt(a.life_id) < parseInt(b.life_id)) return 1;
          return 0
        })
      }
      if (filter == "claim_id") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.claim_id) > parseInt(b.claim_id)) return -1;
          if (parseInt(a.claim_id) < parseInt(b.claim_id)) return 1;
          return 0
        })
      }
      if (filter == "eff_discount") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseFloat((((a.awp_price - a.total_cost) / a.awp_price) * 100)) > parseFloat((((b.awp_price - b.total_cost) / b.awp_price) * 100))) return -1;
          if (parseFloat((((a.awp_price - a.total_cost) / a.awp_price) * 100)) < parseFloat((((b.awp_price - b.total_cost) / b.awp_price) * 100))) return 1;
          return 0
        })
      }
    }
    if (this.participant.length > 0) {
      if (filter == "label_name") {
        this.participant = this.participant.sort(function (a, b) {
          if ((a.label_name) > (b.label_name)) return -1;
          if ((a.label_name) < (b.label_name)) return 1;
          return 0
        })
      }
      if (filter == "total_cost") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.total_cost) > parseInt(b.total_cost)) return -1;
          if (parseInt(a.total_cost) < parseInt(b.total_cost)) return 1;
          return 0
        })
      }
      if (filter == "plan_pay") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return 1;
          return 0
        })
      }
      if (filter == "co_pay") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return 1;
          return 0
        })
      }
      if (filter == "qty") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.qty) > parseInt(b.qty)) return -1;
          if (parseInt(a.qty) < parseInt(b.qty)) return 1;
          return 0
        })
      }
      if (filter == "claims_count") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.claims_count) > parseInt(b.claims_count)) return -1;
          if (parseInt(a.claims_count) < parseInt(b.claims_count)) return 1;
          return 0
        })
      }
      if (filter == "drug_type") {
        this.participant = this.participant.sort(function (a, b) {
          if ((a.drug_type) > (b.drug_type)) return -1;
          if ((a.drug_type) < (b.drug_type)) return 1;
          return 0
        })
      }
      if (filter == "pharmacy_name") {
        this.participant = this.participant.sort(function (a, b) {
          if ((a.pharmacy_name) > (b.pharmacy_name)) return -1;
          if ((a.pharmacy_name) < (b.pharmacy_name)) return 1;
          return 0
        })
      }
    }
  }

  @action sortbyasc(filter) {
    this.filterValue = filter;
    if (this.drug.length > 0) {
      if (filter == "life_id") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.life_id) < parseInt(b.life_id)) return -1;
          if (parseInt(a.life_id) > parseInt(b.life_id)) return 1;
          return 0
        })
      }
      if (filter == "claim_id") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.claim_id) < parseInt(b.claim_id)) return -1;
          if (parseInt(a.claim_id) > parseInt(b.claim_id)) return 1;
          return 0
        })
      }
      if (filter == "total_cost") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.total_cost) < parseInt(b.total_cost)) return -1;
          if (parseInt(a.total_cost) > parseInt(b.total_cost)) return 1;
          return 0
        })
      }
      if (filter == "plan_pay") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return 1;
          return 0
        })
      }
      if (filter == "co_pay") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return 1;
          return 0
        })
      }
      if (filter == "qty") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.qty) < parseInt(b.qty)) return -1;
          if (parseInt(a.qty) > parseInt(b.qty)) return 1;
          return 0
        })
      }
      if (filter == "days_supply") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseInt(a.days_supply) < parseInt(b.days_supply)) return -1;
          if (parseInt(a.days_supply) > parseInt(b.days_supply)) return 1;
          return 0
        })
      }
      if (filter == "pharmacy_name") {
        this.drug = this.drug.sort(function (a, b) {
          if ((a.pharmacy_name) < (b.pharmacy_name)) return -1;
          if ((a.pharmacy_name) > (b.pharmacy_name)) return 1;
          return 0
        })
      }
      if (filter == "date_filled") {
        this.drug = this.drug.sort(function (a, b) {
          if ((a.date_filled) < (b.date_filled)) return -1;
          if ((a.date_filled) > (b.date_filled)) return 1;
          return 0
        })
      }
      if (filter == "eff_discount") {
        this.drug = this.drug.sort(function (a, b) {
          if (parseFloat((((a.awp_price - a.total_cost) / a.awp_price) * 100)) > parseFloat((((b.awp_price - b.total_cost) / b.awp_price) * 100))) return -1;
          if (parseFloat((((a.awp_price - a.total_cost) / a.awp_price) * 100)) < parseFloat((((b.awp_price - b.total_cost) / b.awp_price) * 100))) return 1;
          return 0
        })
      }
    }
    if (this.participant.length > 0) {
      if (filter == "label_name") {
        this.participant = this.participant.sort(function (a, b) {
          if ((a.label_name) < (b.label_name)) return -1;
          if ((a.label_name) > (b.label_name)) return 1;
          return 0
        })
      }
      if (filter == "total_cost") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.total_cost) < parseInt(b.total_cost)) return -1;
          if (parseInt(a.total_cost) > parseInt(b.total_cost)) return 1;
          return 0
        })
      }
      if (filter == "plan_pay") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return 1;
          return 0
        })
      }
      if (filter == "co_pay") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return 1;
          return 0
        })
      }
      if (filter == "qty") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.qty) < parseInt(b.qty)) return -1;
          if (parseInt(a.qty) > parseInt(b.qty)) return 1;
          return 0
        })
      }
      if (filter == "claims_count") {
        this.participant = this.participant.sort(function (a, b) {
          if (parseInt(a.claims_count) < parseInt(b.claims_count)) return -1;
          if (parseInt(a.claims_count) > parseInt(b.claims_count)) return 1;
          return 0
        })
      }
      if (filter == "drug_type") {
        this.participant = this.participant.sort(function (a, b) {
          if ((a.drug_type) < (b.drug_type)) return -1;
          if ((a.drug_type) > (b.drug_type)) return 1;
          return 0
        })
      }
      if (filter == "pharmacy_name") {
        this.participant = this.participant.sort(function (a, b) {
          if ((a.pharmacy_name) < (b.pharmacy_name)) return -1;
          if ((a.pharmacy_name) > (b.pharmacy_name)) return 1;
          return 0
        })
      }
    }
  }

  @action drugDetails = async (data) => {
    this.drug = [];
    try {
      let response = await post(
        `${this.url}/drug`,
        data
      );
      this.drug = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action PharmacyAndPhysicianDetail = async (data) => {
    this.pharmacy_and_physician_detail = [];
    try {
      let response = await post(
        `${this.url}/pharmacy_and_physician_detail`,
        data
      );
      this.pharmacy_and_physician_detail = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }
  @action PharmacyClaimDetails = async (data) => {
    this.pharmacy_claim_detail = [];
    try {
      let response = await post(
        `${this.url}/pharmacy_claim_details`,
        data
      );
      this.pharmacy_claim_detail = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action claimDetails = async (data) => {
    this.claim = [];
    try {
      let response = await post(
        `${this.url}/claim`,
        data
      );

      this.claim = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action pharmacyDetails = async (data) => {
    this.pharmacy = {};
    try {
      let response = await post(
        `${this.url}/pharmacy`,
        data
      );

      this.pharmacy = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action physicianDetails = async (data) => {
    this.physician = [];
    try {
      let response = await post(
        `${this.url}/physician`,
        data
      );

      this.physician = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action participantDetails = async (data) => {
    this.participant = [];
    try {
      let response = await post(
        `${this.url}/participant`,
        data
      );

      this.participant = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action participantOpioid = async (data) => {
    this.participant_opioid = [];
    try {
      let response = await post(
        `${this.url}/participant_opioid`,
        data
      );

      this.participant_opioid = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action getIndividualPharmacyDetails = async (data) => {
    this.individual_pharmacy = {};
    try {
      let response = await post(
        `${this.url}/individualpharmacy`,
        data
      );

      this.individual_pharmacy = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }



}

export default DashboardCommonStore;
